var _style, _filter, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{filter:url(#filter-2);} .st1{fill:#E9E9E9;} .st2{fill:#2B2B2B;}")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "141.7%",
    id: "filter-2",
    width: "137.5%",
    x: "-18.8%",
    y: "-10.4%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Panel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1_4_",
    cx: 16,
    cy: 15,
    r: 12
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-1_1_",
    className: "st1",
    cx: 16,
    cy: 15,
    r: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1_3_",
    className: "st2",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M11.3 9.9l3.5-3.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9.9 8.5 6.4 5c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.5 3.5L5 13.4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.5-3.5 3.5 3.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-3.5-3.5z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/closeIcon.b840635e.svg";
export { ForwardRef as ReactComponent };